import React, { useState, useEffect } from "react";
import { Paper, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { LockTwoTone } from "@mui/icons-material";

const CompanyDetails = () => {
  const [companyDetails, setCompanyDetails] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { cin } = location.state;

  const handlePricing = () => {
    navigate(`/pricing`);
  };

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await fetch(
          `https://nexens.us/nexensus-dmp/website/companies?cin=${cin}`
        );
        console.log("CIn of the company is :", cin);
        console.log("response is for company doc  :", response);

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        setCompanyDetails(data);
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    };

    if (cin) {
      fetchCompanyDetails();
    }
  }, [cin]);

  const formatCompanyDetails = (data) => {
    const companyName = data.name || "N/A";
    const cin = data.cin || "N/A";
    const age = data.incYear
      ? `${(new Date().getFullYear() - data.incYear).toFixed(2)} Years`
      : "N/A";
    const incDate = data.incYear ? `${data.incYear}` : "N/A";
    const state = data.state || "N/A";
    const paidUpCapital = data.paidUpCapital
      ? `${data.paidUpCapital} Millions`
      : "0.00 Millions";
    const authCapital = data.authCapital
      ? `${data.authCapital} Millions`
      : "0.00 Millions";
    const regAddress = data.addrs;
    const directorCount = data.companyDirectors
      ? data.companyDirectors.length
      : 0;
    const financialYear = data.finEndDate || "N/A";
    const lastAGMDate = data.agmDate || "N/A";
    const companyType = data.compClass || "Foreign";
    const ownership = data.ownership || "N/A";
    const category = data.category || "N/A";
    const subCategory = data.subCategory || "N/A";
    const section = data.section || "N/A";

    return `
      <span style="background-color: #f77b07;">${companyName}</span> with CIN <span style="background-color: #f77b07;">${cin}</span>, is a <span style="background-color: #f77b07;">${age}</span>, registered at <span style="background-color: #f77b07;">${regAddress}</span>, with a paid up capital of <span style="background-color: #f77b07;">${paidUpCapital}</span>.
      The status of <span style="background-color: #f77b07;">${companyName}</span>, as on date is <span style="background-color: #f77b07;">${companyType}</span>. Company has filed its Annual Returns and/or Financial Statements up to i.e. FY <span style="background-color: #f77b07;">${financialYear}</span>.
      As on date, <span style="background-color: #f77b07;">${directorCount}</span> Directors are associated with the company.
      As per MCA records, company is registered at; <span style="background-color: #f77b07;">${regAddress}</span>
    `;
  };

  const formatKYCInformation = (data) => {
    const cin = data.cin || "N/A";
    const age = data.incYear
      ? `${(new Date().getFullYear() - data.incYear).toFixed(2)} Years`
      : "N/A";
    const incDate = data.incYear ? `${data.incYear}` : "N/A";
    const paidUpCapital = data.paidUpCapital
      ? `${data.paidUpCapital} Millions`
      : "0.00 Millions";
    const authCapital = data.authCapital
      ? `${data.authCapital} Millions`
      : "0.00 Millions";
    const companyStatus = data.status || "N/A";
    const directorCount = data.companyDirectors
      ? data.companyDirectors.length
      : 0;
    const companyType = data.compClass || "Foreign";
    const ownership = data.ownership || "N/A";
    const category = data.category || "N/A";
    const subCategory = data.subCategory || "N/A";
    const lastAGMDate = data.agmDate || "N/A";
    const balanceSheetDate = data.finEndDate || "N/A";
    const section = data.section || "N/A";
    const regAddress = data.addrs || "N/A";

    return `
KYC Information
Company CIN\t${cin}\tAge (Incorp. Date)\t${age} (${incDate})
Paid up Capital\t${paidUpCapital}\tAuthorization Capital\t${authCapital}
Company Status\t${companyStatus}\tDirectors\tCurrent : ${directorCount}
Company Type\t${companyType}\tOwnership\t${ownership}
Category\t${category}\tSub Category\t${subCategory}
Last AGM Date\t${lastAGMDate}\tBalance Sheet Date\t${balanceSheetDate}
Section\t${section}\tAddress\t${regAddress}
`;
  };

  return (
    <div>
      {companyDetails ? (
        <Paper style={{ padding: "16px" }}>
          <Typography variant="h6">Company Details</Typography>
          <p
            dangerouslySetInnerHTML={{
              __html: formatCompanyDetails(companyDetails),
            }}
          ></p>
          <Typography variant="h6">KYC Information</Typography>

          <pre
            style={{
              filter: "blur(5px)",
              pointerEvents: "none",
            }}
          >
            {formatKYCInformation(companyDetails)}
          </pre>
          <button
              onClick={handlePricing}
              style={{
                position: "absolute",
                top: "90%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "transparent",
                border: "none",
                cursor: "pointer",
                pointerEvents: "auto",
              }}
            >
              <LockTwoTone sx={{ color: "red", fontSize: "3rem" }} />
            </button>
        </Paper>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default CompanyDetails;
